import React from "react"

import {ItemIconDict} from "../../../../gd/const/item-icon/icon/icons"
import {FinderNoteItemType} from "./@types"

type Props = {
    noteItem        : FinderNoteItemType

    isHighlighted   : boolean

    onClickNote     : func
}

export default class FinderNote extends React.Component<Props> {

    // is called outside by ref
    click = () => {
        return this.onClickNote()
    }

    onClickNote = (e?: React.MouseEvent) => {
        e?.stopPropagation()
        if (this.props.onClickNote) {
            return this.props.onClickNote(this.props.noteItem)
        }
    }

    render() {
        const classes = Classes("search-item note flex-row-left-center", {
            'is-highlighted': this.props.isHighlighted,
        })

        const icon = this.props.noteItem.noteType && ItemIconDict[this.props.noteItem.noteType.icon] ? ItemIconDict[this.props.noteItem.noteType.icon].className : 'ii5-task-list'
        const iconClasses = Classes("search-item-icon note-icon", icon)

        return (
            <div className = {classes}
                 onClick   = {this.onClickNote}>
                <div className={iconClasses}/>
                <div className="search-item-title flex-1">{this.props.noteItem.name}</div>
            </div>
        )
    }
}
